import {Component, OnInit} from '@angular/core'
import {AngularFirestore} from 'angularfire2/firestore'
import {Router, ActivatedRoute} from '@angular/router'
import {BrandService} from '../brand.service'

const BRANDCOLLECTION = 'brands'
const DEFAULTFOLDERBRANDING = {
  color_contrast: ['#6ADB7F', '#000000'],
  color_primary: ['#208EF1', '#ffffff'],
  color_shade: ['#0061BE', '#FFFFFF'],
  logo: './assets/img/logo-attaboy.png',
}

@Component({
  selector: 'app-brand-edit',
  templateUrl: './brand-edit.component.html',
  providers: [BrandService],
  styleUrls: ['./brand-edit.component.scss'],
})
export class BrandEditComponent implements OnInit {
  brand: any
  logos_suggestions

  constructor(
    private firestore: AngularFirestore,
    public router: Router,
    public route: ActivatedRoute,
    public brandService: BrandService
  ) {}

  ngOnInit() {
    this.route.params.subscribe(({brandId}) => {
      this.firestore
        .doc([BRANDCOLLECTION, brandId].join('/'))
        .valueChanges()
        .subscribe(brand => {
          this.brand = brand
          this.brand.color_primary = this.brand.color_primary || [null, null]
          this.brand.color_shade = this.brand.color_shade || [null, null]
          this.brand.color_contrast = this.brand.color_contrast || [null, null]
        })
    })
  }

  update() {
    // Delete values if default
    let _brand = this.brand
    if (_brand.name !== 'Attaboy') {
      if (_brand.logo == DEFAULTFOLDERBRANDING.logo) delete _brand.logo
      if (
        JSON.stringify(_brand.color_primary) ==
          JSON.stringify(DEFAULTFOLDERBRANDING.color_primary) &&
        JSON.stringify(_brand.color_shade) ==
          JSON.stringify(DEFAULTFOLDERBRANDING.color_shade) &&
        JSON.stringify(_brand.color_contrast) ==
          JSON.stringify(DEFAULTFOLDERBRANDING.color_contrast)
      ) {
        delete _brand.color_primary
        delete _brand.color_shade
        delete _brand.color_contrast
      }
      this.firestore
        .doc([BRANDCOLLECTION, _brand.id].join('/'))
        .ref.set(_brand, {merge: true})
    }
  }

  get DEFAULTFOLDERBRANDING() {
    return DEFAULTFOLDERBRANDING
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/brand/brand-edit/brand-edit.component.ts